<template>
  <li class="dropdown messages-menu">
    <a href="#" class="dropdown-toggle" data-toggle="dropdown">{{ projectSelectedDisplay }}</a>
    <ul class="dropdown-menu">
      <li class="header">You have {{ listData.length  }} project(s)</li>
      <li v-if="listData.length > 0">
        <ul class="menu">
          <project-item v-for="project in listData"
              :key="project.id"
              :project="project"
              v-on:onChooseProject="chooseSelectedProject($event)">
          </project-item>
        </ul>
      </li>
      <li class="footer" v-if="listData.length > 1">
        <a href="#" @click="onChooseAllProject()">View All Project(s)</a>
      </li>
    </ul>
  </li>
</template>

<script>
import api from '../../api'
import SweetAlert from 'sweetalert2'
import ProjectItem from './ProjectItem'

export default {
  name: 'ProjectMenu',
  components: {
    ProjectItem
  },
  data() {
    return {
      projectSelected: 0,
      projectSelectedDisplay: '',
      listData: []
    }
  },
  computed: {
  },
  created() {
    this.getUserProject()
  },
  mounted() {
  },
  methods: {
    getUserProject() {
      api
        .request('Account', 'get', '/api/Project/GetUserProject', null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
        })
        .then(response => {
          this.projectSelected = 0
          this.$store.commit('SET_PROJECT', this.projectSelected)
          this.displaySelectedProject(this.projectSelected)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    displaySelectedProject(projectIdSelected) {
      this.projectSelected = projectIdSelected

      let projectTobeSearch = []
      let projectSelectedDetail
      if (this.projectSelected === 0) {
        this.listData.forEach(e => {
          projectTobeSearch.push(e.id)
        })
        this.projectSelectedDisplay = 'All Project(s)'
      } else {
        projectTobeSearch.push(this.projectSelected)
        this.projectSelectedDisplay = this.listData.filter(e => { return e.id === projectIdSelected })[0].name
      }

      this.$store.commit('SET_PROJECT', projectTobeSearch)

      if (projectTobeSearch.length === 1) {
        projectSelectedDetail = this.listData.filter(e => { return e.id === projectTobeSearch[0] })[0]
      }

      this.inquiryByProject(projectTobeSearch, projectSelectedDetail)
    },
    inquiryByProject(projectTobeSearch, projectSelectedDetail) {
      // https://www.semicolonworld.com/question/64777/vue-js-call-component-method-from-another-component
      switch (this.$route.name) {
        case 'Dashboard':
          this.$root.$emit('inquiryDashboardByProject', projectTobeSearch)
          break
        case 'Membership':
          this.$root.$emit('inquiryMembershipByProject', projectTobeSearch)
          break
        case 'Product':
          this.$root.$emit('inquiryProductByProject', projectTobeSearch)
          break
        case 'Price':
          this.$root.$emit('inquiryPriceByProject', projectTobeSearch)
          break
        case 'Sales Order':
          this.$root.$emit('inquirySalesOrderByProject', projectTobeSearch)
          break
        case 'Invoice':
          this.$root.$emit('inquiryInvoiceByProject', projectTobeSearch)
          break
        case 'PaymentOrderList':
          this.$root.$emit('inquiryPaymentOrderByProject', projectTobeSearch)
          break
        case 'PaymentList':
          this.$root.$emit('inquiryPaymentByProject', projectTobeSearch)
          break
        case 'PaymentClearing':
          this.$root.$emit('inquiryPaymentClearingByProject', projectTobeSearch, projectSelectedDetail)
          break
        case 'PaymentClearingList':
          this.$root.$emit('inquiryPaymentClearingSessionByProject', projectTobeSearch)
          break
        case 'PassCode':
          this.$root.$emit('inquiryPassCodeByProject', projectTobeSearch)
          break
        case 'Gate':
          this.$root.$emit('inquiryGateByProject', projectTobeSearch)
          break
        case 'Holiday':
          this.$root.$emit('inquiryHolidayByProject', projectTobeSearch)
          break
        case 'WorkingCalendar':
          this.$root.$emit('inquiryWorkingCalendarByProject', projectTobeSearch)
          break
        case 'Report':
          this.$root.$emit('generateReport', projectTobeSearch, projectSelectedDetail)
          break
        case 'BankAccount':
          this.$root.$emit('inquiryBankAccountByProject', projectTobeSearch)
          break
        case 'CheckInOutLocation':
          this.$root.$emit('inquiryCheckInOutLocationByProject', projectTobeSearch)
          break
        default:
          break
      }
    },
    onChooseAllProject() {
      this.displaySelectedProject(0)
    },
    chooseSelectedProject(projectId) {
      this.displaySelectedProject(projectId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProjectMenu.vue?2f51ebdb